//import { TitleProps } from "types/express";

export const sidebarItems = [
  {
    icon: "pulse",
    title: "Leads",
    baseUrl: "/dashboard",
    subRoutes: [
      {
        label: "Website Visitors",
        url: "/website-visitors",
      },
      {
        label: "Form Enrichment",
        url: "/form-enrichment",
      },
      {
        label: "Social Intent",
        url: "/social-intent",
      },
    ],
  },
  {
    icon: "search",
    title: "Database",
    baseUrl: "/database",
    url: "/database",
  },
  {
    icon: "score",
    title: "Lead Scoring",
    baseUrl: "/lead-scoring",
    subRoutes: [
      {
        label: "ICP Filters",
        url: "/filters",
      },
      {
        label: "Page Intent",
        url: "/page-intent",
      },
      {
        label: "Reveal Thresholds",
        url: "/minimum-score",
      },
    ],
  },
  {
    icon: "analytics",
    title: "Analytics",
    baseUrl: "/analytics",
    url: "/analytics",
  },
  {
    icon: "settings",
    title: "Settings",
    baseUrl: "/settings",
    subRoutes: [
      {
        label: "Integrations",
        url: "/integrations",
        onlyAdmin: true,
      },
      {
        label: "Tracking Pixel",
        url: "/pixel",
      },
      {
        label: "Company Team",
        url: "/company-team",
      },
      {
        label: "Webhooks",
        url: "/webhooks",
        onlyAdmin: true,
      },
      {
        label: "API Key",
        url: "/api-key",
        onlyAdmin: true,
      },
    ],
  },
];
// export const titles: TitleProps = {
//   leads: {
//     title: "Leads",
//     subtitle: "Lead with your ICP information",
//     icon: "pulse",
//   },
//   //   company: {
//   //     title: "Team",
//   //     subtitle:
//   //       "Get your project up and running faster by directly inviting your team members to your company.",
//   //     icon: "people",
//   //   },
//   pageIntent: {
//     title: "Social Intent",
//     subtitle: "Social Intent",
//     icon: "globe",
//   },
//   pixel: {
//     title: "Tracking Pixel",
//     subtitle: "Track your website visitors",
//     icon: "code",
//   },
//   database: {
//     title: "Database",
//     subtitle: "Search and filter leads",
//     icon: "search",
//   },
//   settings: {
//     title: "Settings",
//     subtitle: "Settings with your favorite tools",
//     icon: "settings",
//   },
//   scoring: {
//     title: "Lead Scoring",
//     subtitle: "Configure your lead scoring",
//     icon: "score",
//   },
//   analytics: {
//     title: "Analytics",
//     subtitle: "Analyse your statics",
//     icon: "analytics",
//   },
// };
